import { useEffect, useState } from "react";
import { Menu, X, MessageCircle } from "lucide-react";
import { Logo } from "./Logo";
import { waLink, WA_DEFAULT_MSG, scrollToId } from "../lib/site";
import { useContent } from "../context/ContentContext";

const NAV = [
  { label: "Inicio", href: "#inicio", testid: "nav-inicio" },
  { label: "Líneas", href: "#lineas", testid: "nav-lineas" },
  { label: "Catálogo", href: "#catalogo", testid: "nav-catalogo" },
  { label: "Calidad", href: "#calidad", testid: "nav-calidad" },
  { label: "Nosotros", href: "#nosotros", testid: "nav-nosotros" },
  { label: "Contacto", href: "#contacto", testid: "nav-contacto" },
];

export default function Header() {
  const content = useContent();
  const wa = waLink(WA_DEFAULT_MSG, content.whatsapp_number);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => (document.body.style.overflow = "");
  }, [open]);

  const go = (e, href) => {
    e.preventDefault();
    setOpen(false);
    scrollToId(href);
  };

  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 border-b border-[#E8E4D9] bg-white/90 backdrop-blur-xl"
      data-testid="site-header"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-2.5 lg:px-8">
        <a
          href="#inicio"
          onClick={(e) => go(e, "#inicio")}
          className="flex items-center gap-3"
          data-testid="brand-home-link"
        >
          <Logo className="h-10 w-auto" />
          <span className="font-mono hidden text-[10px] uppercase tracking-[0.3em] text-brand sm:block">
            Dominicana
          </span>
        </a>

        <nav className="hidden items-center gap-7 lg:flex" data-testid="main-nav">
          {NAV.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e) => go(e, item.href)}
              data-testid={item.testid}
              className="text-sm font-medium text-neutral-600 transition-colors duration-200 hover:text-brand"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={wa}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="header-whatsapp-button"
            className="hidden items-center gap-2 rounded-full bg-wa px-5 py-2.5 text-sm font-bold text-black transition-all duration-200 hover:bg-wa-hover hover:scale-105 sm:flex"
          >
            <MessageCircle size={16} strokeWidth={2.5} />
            Pedir por WhatsApp
          </a>
          <button
            onClick={() => setOpen(!open)}
            data-testid="mobile-menu-toggle"
            className="rounded-lg border border-neutral-200 p-2 text-neutral-700 lg:hidden"
            aria-label="Abrir menú"
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-[#E8E4D9] bg-white lg:hidden" data-testid="mobile-menu">
          <nav className="flex flex-col px-5 py-4">
            {NAV.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => go(e, item.href)}
                data-testid={`mobile-${item.testid}`}
                className="border-b border-neutral-100 py-3 text-sm font-medium text-neutral-700"
              >
                {item.label}
              </a>
            ))}
            <a
              href={wa}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="mobile-whatsapp-button"
              className="mt-4 flex items-center justify-center gap-2 rounded-full bg-wa px-5 py-3 text-sm font-bold text-black"
            >
              <MessageCircle size={16} strokeWidth={2.5} />
              Pedir por WhatsApp
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}
